module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/breakdowns/breakdowns-list/breakdowns-list.component.css
// module id = ./src/app/breakdowns/breakdowns-list/breakdowns-list.component.css
// module chunks = main